import {Component, Input} from '@angular/core';
import {DbActiveModal} from "../../../../modules/modal/modal-ref";
import {Website} from "../../website";
import {IOPagesData} from "../mappers/io-list";
// import {GoogleButton} from "ngx-sharebuttons/classes";
import {GoogleAnalyticsService} from "../../../../shared/services/google-analytics/google-analytics.service";

 const FEATURES = [
   '90+ PageSpeed score',
   'Improved core web vitals',
   'Full website caching',
   'Improved Google rankings',
 ];

@Component({
    selector: 'db-image-optimizer-success',
    templateUrl: './image-optimizer-success.component.html',
    styleUrls: ['./image-optimizer-success.component.scss'],
    standalone: false
})
export class ImageOptimizerSuccessComponent {

  @Input() website: Website;
  @Input() report: IOPagesData;
  @Input() currentScore: any;

  public features = FEATURES;

  constructor(
    private readonly activeModal: DbActiveModal,
    private readonly _googleAnalyticsService: GoogleAnalyticsService
  ) { }

  public redirectToWp(): void {
    window.open(this.website.adminActivateBoosterUrl, "_blank", "noopener");
    this.activeModal.close();
  }

}
